import { render } from "./ApplicantWorkCard.vue?vue&type=template&id=5185c057&scoped=true"
import script from "./ApplicantWorkCard.vue?vue&type=script&lang=js"
export * from "./ApplicantWorkCard.vue?vue&type=script&lang=js"

import "./ApplicantWorkCard.vue?vue&type=style&index=0&id=5185c057&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5185c057"]])

export default __exports__